var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressIndicator25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10 0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10zm-15 0c0 2.7614 2.23858 5 5 5 2.7614 0 5-2.2386 5-5 0-2.76142-2.2386-5-5-5-2.76142 0-5 2.23858-5 5z",
    fill: "#98a2b3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 2c1.3132 0 2.6136.25866 3.8268.7612 1.2133.50255 2.3157 1.23915 3.2443 2.16773.9286.92859 1.6651 2.03098 2.1677 3.24424.5025 1.21325.7612 2.51363.7612 3.82683h-5c0-.6566-.1293-1.3068-.3806-1.9134-.2513-.60664-.6196-1.15784-1.0839-1.62213-.4643-.4643-1.0155-.83259-1.6221-1.08387-.6066-.25127-1.2568-.3806-1.9134-.3806z",
    fill: "#cf2f92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIndicator25);
export default __webpack_public_path__ + "static/media/ProgressIndicator25.528192d1d9dcb8a54130444fd009d3c4.svg";
export { ForwardRef as ReactComponent };